import { render, staticRenderFns } from "./DailyStandupComponent.vue?vue&type=template&id=4d7e8c94&"
import script from "./DailyStandupComponent.vue?vue&type=script&lang=js&"
export * from "./DailyStandupComponent.vue?vue&type=script&lang=js&"
import style0 from "./DailyStandupComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports